"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/itSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ItSectionHowFifteenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Choose Your Specialist" | "Book Your Session" | "Start Your Healing Journey" */
    h30Text: ReactNode;
    /** Detected variants: "Browse trusted mental health professionals and select the right therapist based on your needs and preferences." | "Pick a convenient date and time, and schedule your of you and appointment quickly and securely online." | "Connect with your therapist, share your concerns, and begin your path toward better mental well-being." */
    p0Text: ReactNode;
    /** Detected variants: "STEP 1" | "STEP 2" | "STEP 3" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/icons/how-icon-1.svg" | "/Templates/Doccure/img/icons/how-icon-2.svg" | "/Templates/Doccure/img/icons/how-icon-3.svg" */
    src: string;
    /** Detected variants: "how-item-fifteen wow fadeInUp" */
    className?: string;
    /** Detected variants: "2s" */
    dataWowDuration?: string;
    /** Detected variants: "how-inner-title" */
    div0ClassName?: string;
    /** Detected variants: "how-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "how-subtitle" */
    span0ClassName?: string;
    /** Detected variants: "how-item-img" */
    div1ClassName?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid icon-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "icon" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid icon-2" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/how-icon-4.svg" */
    imageWithBasePath1Src?: string;
};
export type HomeFifteenItSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ItSectionHowFifteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ItSectionHowFifteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ItSectionHowFifteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "2s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "How It Works" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "How Booking Process" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Works For You" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "choose" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/features/choose-img-2.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    itSectionHowFifteenFadeInUps: ItSectionHowFifteenFadeInUpsItem[];
    itSectionHowFifteenFadeInUpsItemWrapper?: (item: ItSectionHowFifteenFadeInUpsItem, content: ReactNode) => ReactNode;
    itSectionHowFifteenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    itSectionHowFifteenFadeInUpsImageVisible?: boolean;
    itSectionHowFifteenFadeInUpsImageRenderer?: (item: ItSectionHowFifteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    itSectionHowFifteenFadeInUpsH3Visible?: boolean;
    itSectionHowFifteenFadeInUpsH3Renderer?: (item: ItSectionHowFifteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    itSectionHowFifteenFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ItSectionHowFifteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    itSectionHowFifteenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: ItSectionHowFifteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFifteenItSectionGenerated: FC<HomeFifteenItSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "How It Works",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Div0Div0H20H2Text = "How Booking Process",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Works For You",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "choose",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/features/choose-img-2.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv1ImageWithBasePath0ImageProps,
    divDiv1ImageWithBasePath1ImageProps,
    sectionDiv0Div0ClassName,
    itSectionHowFifteenFadeInUps,
    itSectionHowFifteenFadeInUpsItemWrapper,
    itSectionHowFifteenFadeInUpsRenderer,
    itSectionHowFifteenFadeInUpsImageVisible,
    itSectionHowFifteenFadeInUpsImageRenderer,
    itSectionHowFifteenFadeInUpsH3Visible,
    itSectionHowFifteenFadeInUpsH3Renderer,
    itSectionHowFifteenFadeInUpsImageProps,
    itSectionHowFifteenFadeInUpsH3Props,
}) => {
    return (
        <section className="section how-section-fifteen">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-xl-6">
                        <div className="section-header section-header-fifteen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <br />
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                        {renderCollectionNode(
                            itSectionHowFifteenFadeInUps,
                            (item: ItSectionHowFifteenFadeInUpsItem) => (
                                <div className={item.className ?? "how-item-fifteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "2s"} key={item.key}>
                                    <div className={item.div0ClassName ?? "how-inner-title"}>
                                        <span className={item.span0ClassName ?? "how-subtitle"}>{item.span0Text}</span>
                                        {renderItemNode(itSectionHowFifteenFadeInUpsH3Visible, itSectionHowFifteenFadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "how-title"} {...(typeof itSectionHowFifteenFadeInUpsH3Props === "function" ? itSectionHowFifteenFadeInUpsH3Props(item) : (itSectionHowFifteenFadeInUpsH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                    <div className={item.div1ClassName ?? "how-item-img"}>
                                        {renderItemNode(itSectionHowFifteenFadeInUpsImageVisible, itSectionHowFifteenFadeInUpsImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon-1"} {...(typeof itSectionHowFifteenFadeInUpsImageProps === "function" ? itSectionHowFifteenFadeInUpsImageProps(item) : (itSectionHowFifteenFadeInUpsImageProps ?? {}))} {...(typeof divDiv1ImageWithBasePath0ImageProps === "function" ? divDiv1ImageWithBasePath0ImageProps(item) : (divDiv1ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(itSectionHowFifteenFadeInUpsImageVisible, itSectionHowFifteenFadeInUpsImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath1Src ?? "/Templates/Doccure/img/icons/how-icon-4.svg"} alt={item.imageWithBasePath1Alt ?? "icon"} className={item.imageWithBasePath1ClassName ?? "img-fluid icon-2"} {...(typeof itSectionHowFifteenFadeInUpsImageProps === "function" ? itSectionHowFifteenFadeInUpsImageProps(item) : (itSectionHowFifteenFadeInUpsImageProps ?? {}))} {...(typeof divDiv1ImageWithBasePath1ImageProps === "function" ? divDiv1ImageWithBasePath1ImageProps(item) : (divDiv1ImageWithBasePath1ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                </div>
                            ),
                            itSectionHowFifteenFadeInUpsItemWrapper,
                            itSectionHowFifteenFadeInUpsRenderer
                        )}
                    </div>
                    <div className="col-xl-6">
                        <div className="how-img-fifteen ps-5 d-none d-xl-block">
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFifteenItSectionGenerated;
